@if (days !== '00') {
  <div class="days">
    <span class="label">day</span>
    <span class="value">{{ days }}:</span>
  </div>
}

<div>
  <span class="label">hr</span>
  <span class="value">{{ hours }}:</span>
</div>

<div>
  <span class="label">min</span>
  <span class="value">{{ minutes }}:</span>
</div>

<div>
  <span class="label">sec</span>
  <span class="value">{{ seconds }}</span>
</div>
